<script>
export default {
  name: 'OtherMobile',
};
</script>

<template>
  <div>
    <!-- Other Mobile -->
    <p class="body-2">
      Note: This is a web app so you can install it right from here. Once you do, it works just like
      other apps&mdash;even offline. Plus, you never have to install updates and it works on every
      device.
    </p>

    <p>Look for an option to "Add to Home screen" in your mobile browser.</p>

    <p>For example, you might see:</p>
    <ul>
      <li>
        An icon next to the URL bar
        <span class="nobr">
          like&nbsp;
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 86.6 74.6"
            style="enable-background:new 0 0 86.6 74.6;"
            xml:space="preserve"
            class="inline-icon"
          >
            <path
              d="M45.2,0.8c-1-1.1-2.8-1.1-3.8,0c0,0,0,0,0,0L0.8,43c-1.1,1.1-1.1,2.9,0,4s2.8,1.1,3.8,0l0,0l7.7-8v32.8
	c0,1.6,1.2,2.8,2.7,2.8h56.5c1.5,0,2.7-1.3,2.7-2.8V39l7.7,8c1.1,1.1,2.8,1.1,3.8,0c1.1-1.1,1.1-2.9,0-4l0,0L45.2,0.8z M68.9,69
	H17.7V33.4L43.3,6.8l25.6,26.6V69z"
            />
            <path
              d="M40.5,36.4v6.9h-6.9c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8c0,0,0,0,0,0h6.9v6.9c0,1.6,1.3,2.8,2.8,2.8
	c1.6,0,2.8-1.3,2.8-2.8V49H53c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8h-6.9v-6.9c0-1.6-1.3-2.8-2.8-2.8
	C41.8,33.6,40.5,34.9,40.5,36.4z"
            />
          </svg>
          &nbsp;or&nbsp;
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 63 63"
            style="enable-background:new 0 0 63 63;"
            xml:space="preserve"
            class="inline-icon"
          >
            <g>
              <g>
                <path
                  d="M31.5,0C0,0,0,14.6,0,31.5C0,48.4,0,63,31.5,63C63,63,63,48.4,63,31.5C63,14.6,63,0,31.5,0z M31.5,61C2,61,2,48.6,2,31.5
			C2,14.4,2,2,31.5,2C61,2,61,14.4,61,31.5C61,48.6,61,61,31.5,61z"
                />
                <path
                  d="M41.6,39.9l-8.6,7.3V12.7c0-0.7-0.7-1.3-1.6-1.3c-0.9,0-1.6,0.6-1.6,1.3v34.4l-8.6-7.3c-0.6-0.5-1.6-0.5-2.2,0
			c-0.6,0.5-0.6,1.3,0,1.8l11.2,9.5c0,0,0,0,0,0c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0,0,0,0,0,0l11.2-9.5c0.6-0.5,0.6-1.3,0-1.8C43.2,39.3,42.2,39.3,41.6,39.9z"
                />
              </g>
            </g>
          </svg>
        </span>
      </li>

      <li>
        An
        <strong>Add to Home screen</strong> option under your browser's menu
        <span class="nobr">
          (
          <v-icon class="material-icons-round inline-icon">more_vert</v-icon>&nbsp;or
          <v-icon class="material-icons-round inline-icon">menu</v-icon>&nbsp;)
        </span>
      </li>
    </ul>
    <p>If you don't see this option, you can install the app from Chrome. Or you can always view the app in your browser and bookmark it.</p>
  </div>
</template>

<style lang="scss" scoped>
</style>
